import { useTranslation, UseTranslationOptions } from 'react-i18next';
import { brandTerms, BRAND } from '@/i18n/brandTerms';

/**
 * Custom hook that wraps useTranslation and provides access to brand terms
 * Use this instead of useTranslation directly to ensure brand consistency
 */
export const useBrickTranslation = (ns?: string | string[], options?: UseTranslationOptions<string>) => {
  const translation = useTranslation(ns, options);

  return {
    ...translation,
    // Access to brand terms that should never be translated
    brand: brandTerms,
    // Access to organized brand structure
    BRAND,
    // Helper to interpolate brand terms into a string
    withBrand: (key: string, extraVars?: Record<string, string>) => {
      return translation.t(key, { ...brandTerms, ...extraVars });
    },
  };
};
